import { render, staticRenderFns } from "./ProductNotes.vue?vue&type=template&id=52a051bf"
import script from "./ProductNotes.vue?vue&type=script&lang=js"
export * from "./ProductNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports